import { useState, useEffect } from 'react';
import throttle from 'lodash/throttle';
import { ReactHookEffectMountUnmount } from './constants';
var getPosition = function () { return ({
    x: typeof window !== 'undefined' ? window.pageXOffset : 0,
    y: typeof window !== 'undefined' ? window.pageYOffset : 0,
}); };
function useWindowScrollPosition(throttleMs, enabled) {
    if (enabled === void 0) { enabled = true; }
    var _a = useState(getPosition()), position = _a[0], setPosition = _a[1];
    useEffect(function () {
        if (!enabled) {
            return;
        }
        var handleScroll = throttle(function () {
            requestAnimationFrame(function () {
                setPosition(getPosition());
            });
        }, throttleMs);
        window.addEventListener('scroll', handleScroll, { passive: true });
        return function () {
            window.removeEventListener('scroll', handleScroll);
        };
    }, ReactHookEffectMountUnmount);
    return position;
}
export default useWindowScrollPosition;
//# sourceMappingURL=useWindowScrollPosition.js.map